import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '../core/constants';

@Injectable({
  providedIn: 'root'
})
export class ConfigsLoaderService {

  appVersion: string = "";

  private httpClient: HttpClient;
  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }
  get AppVersion() {
    return this.appVersion;
  }
  // get ConfigsLoadedFrom() {
  //   return this.configs.ConfigsLoadedFrom;
  // }
  public async loadConfigs(): Promise<any> {
    return this.httpClient.get('assets/configs.json').pipe(settings => settings)
      .toPromise()
      .then((settings: any) => {
        this.appVersion = settings && settings !== null ? settings.AppVersion : Constants.AppVersion;
      });
  }

}

